var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomersNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1047_38118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 9.68582C14.2523 9.68582 16.0781 7.85998 16.0781 5.6077C16.0781 3.35541 14.2523 1.52957 12 1.52957C9.74771 1.52957 7.92188 3.35541 7.92188 5.6077C7.92188 7.85998 9.74771 9.68582 12 9.68582Z",
    fill: "#ABB5BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 9.68576C21.6739 9.68576 22.8281 8.5315 22.8281 7.10764C22.8281 5.68378 21.6739 4.52951 20.25 4.52951C18.8261 4.52951 17.6719 5.68378 17.6719 7.10764C17.6719 8.5315 18.8261 9.68576 20.25 9.68576Z",
    fill: "#ABB5BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.68576C5.17386 9.68576 6.32812 8.5315 6.32812 7.10764C6.32812 5.68378 5.17386 4.52951 3.75 4.52951C2.32614 4.52951 1.17188 5.68378 1.17188 7.10764C1.17188 8.5315 2.32614 9.68576 3.75 9.68576Z",
    fill: "#ABB5BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29016 12.001C5.27531 11.1695 4.35623 11.2796 3.18281 11.2796C1.42781 11.2796 0 12.6989 0 14.4432V19.5624C0 20.3199 0.618281 20.9358 1.37859 20.9358C4.66106 20.9358 4.26562 20.9952 4.26562 20.7943C4.26562 17.1668 3.83597 14.5066 6.29016 12.001Z",
    fill: "#ABB5BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1161 11.2983C11.0665 11.1273 9.28506 11.3002 7.74845 12.5686C5.17703 14.6283 5.67189 17.4015 5.67189 20.7942C5.67189 21.6918 6.4022 22.4358 7.31345 22.4358C17.2079 22.4358 17.6017 22.7549 18.1885 21.4556C18.3809 21.0162 18.3281 21.1558 18.3281 16.9523C18.3281 13.6136 15.4372 11.2983 13.1161 11.2983Z",
    fill: "#ABB5BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8172 11.2795C19.6373 11.2795 18.7233 11.1706 17.7098 12.0009C20.1457 14.4879 19.7344 16.9666 19.7344 20.7942C19.7344 20.9964 19.4061 20.9358 22.5722 20.9358C23.3597 20.9358 24 20.2978 24 19.5136V14.4431C24 12.6989 22.5722 11.2795 20.8172 11.2795Z",
    fill: "#ABB5BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1047_38118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersNormal);
export default __webpack_public_path__ + "static/media/customers_normal.0a5c1f67cb710a45bb9f29a52853bf85.svg";
export { ForwardRef as ReactComponent };